import * as React from 'react';
import { SVGProps } from 'react';

const IconStrikethroughSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 14h2v-4H7v4zM3 2v2h4v2h2V4h4V2H3zM2 9h12V7H2v2z" />
  </svg>
);
export default IconStrikethroughSizeS;
